/* eslint-disable spellcheck/spell-checker */
import Service from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import confetti from 'canvas-confetti';

type AudioAsset = {
  language: string;
  name: string;
  audio: string;
};

type LoadedAsset = {
  asset: AudioAsset;
  element: HTMLAudioElement;
};

type Person = {
  name: string;
  title: string;
  image: string;
};

const PEOPLE: Record<string, Person> = {
  Cherylyn: {
    name: 'Cherylyn Wilson',
    title: 'Sr. People Operations Manager',
    image: new URL('cio/assets/images/april-fools/cherylyn.jpg', import.meta.url).toString(),
  },
  Ryan: {
    name: 'Ryan Stahulak',
    title: 'Customer Success Manager',
    image: new URL('cio/assets/images/april-fools/ryan.jpeg', import.meta.url).toString(),
  },
  Alyssa: {
    name: 'Alyssa Welch',
    title: 'People & Culture Specialist',
    image: new URL('cio/assets/images/april-fools/alyssa.jpeg', import.meta.url).toString(),
  },
  Chad: {
    name: 'Chad Glosier',
    title: 'Senior Technical Writer',
    image: new URL('cio/assets/images/april-fools/chad.jpeg', import.meta.url).toString(),
  },
  Nat: {
    name: 'Natalie Onions',
    title: 'VP of Customers',
    image: new URL('cio/assets/images/april-fools/nat.jpeg', import.meta.url).toString(),
  },
  Bill: {
    name: 'Bill Miksich',
    title: 'Head of Solutions',
    image: new URL('cio/assets/images/april-fools/bill.jpeg', import.meta.url).toString(),
  },
  Sarah: {
    name: 'Sarah Audino',
    title: 'Sr. Account Executive',
    image: new URL('cio/assets/images/april-fools/sarah.jpeg', import.meta.url).toString(),
  },
  Colin: {
    name: 'Colin Nederkoorn',
    title: 'CEO',
    image: new URL('cio/assets/images/april-fools/colin.jpeg', import.meta.url).toString(),
  },
  Rachel: {
    name: 'Rachel Cobb',
    title: 'Customer Success - Team Lead',
    image: new URL('cio/assets/images/april-fools/rachel.jpg', import.meta.url).toString(),
  },
  Alexa: {
    name: 'Alexa Davis',
    title: 'Sales Development Representative',
    image: new URL('cio/assets/images/april-fools/alexa.jpeg', import.meta.url).toString(),
  },
  Bri: {
    name: 'Briana Payne',
    title: 'Sales Development Representative',
    image: new URL('cio/assets/images/april-fools/bri.jpeg', import.meta.url).toString(),
  },
  Caitlin: {
    name: 'Caitlin Boatright',
    title: 'TSE Team Lead',
    image: new URL('cio/assets/images/april-fools/caitlin.jpeg', import.meta.url).toString(),
  },
  Bekah: {
    name: 'Bekah Hackley',
    title: 'Sales Operations Coordinator',
    image: new URL('cio/assets/images/april-fools/bekah.jpeg', import.meta.url).toString(),
  },
  Colby: {
    name: 'Colby Ausen',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/colby.jpeg', import.meta.url).toString(),
  },
  Ali: {
    name: 'Ali Simmons',
    title: 'People Partner',
    image: new URL('cio/assets/images/april-fools/ali.jpeg', import.meta.url).toString(),
  },
  Jess: {
    name: 'Jess Cvija',
    title: 'Customer Success Manager',
    image: new URL('cio/assets/images/april-fools/jess.jpeg', import.meta.url).toString(),
  },
  Aaron: {
    name: 'Aaron Rich',
    title: 'Technical Support Engineer',
    image: new URL('cio/assets/images/april-fools/aaron.jpeg', import.meta.url).toString(),
  },
  Aman: {
    name: 'Amandeep Kaur',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/aman.jpeg', import.meta.url).toString(),
  },
  Elena: {
    name: 'Elena Teplushkina',
    title: 'Customer Success Manager',
    image: new URL('cio/assets/images/april-fools/elena.jpeg', import.meta.url).toString(),
  },
  Gladys: {
    name: 'Gladys Khakimova',
    title: 'Customer Success Manager',
    image: new URL('cio/assets/images/april-fools/gladys.jpeg', import.meta.url).toString(),
  },
  Marcela: {
    name: 'Marcela Rodriguez',
    title: 'Customer Success Manager',
    image: new URL('cio/assets/images/april-fools/marcela.jpeg', import.meta.url).toString(),
  },
  Pablo: {
    name: 'Pablo Garcia Montes',
    title: 'Sr. Product Manager',
    image: new URL('cio/assets/images/april-fools/pablo.jpeg', import.meta.url).toString(),
  },
  Adrian: {
    name: 'Adrian Zalewski',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/adrian.jpeg', import.meta.url).toString(),
  },
  Tomasz: {
    name: 'Tomasz Kaczynski',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/tomasz.jpg', import.meta.url).toString(),
  },
  Debbie: {
    name: 'Debbie Otuagomah',
    title: 'TSE Team Lead',
    image: new URL('cio/assets/images/april-fools/debbie.jpeg', import.meta.url).toString(),
  },
  Koko: {
    name: 'Oluwaseun Ilesanmi',
    title: 'Software',
    image: new URL('cio/assets/images/april-fools/koko.jpeg', import.meta.url).toString(),
  },
  JP: {
    name: 'Jp Valery',
    title: 'Customer Success - Team Lead',
    image: new URL('cio/assets/images/april-fools/jp.jpeg', import.meta.url).toString(),
  },
  Waqas: {
    name: 'Waqas Younas',
    title: 'QA Engineer',
    image: new URL('cio/assets/images/april-fools/waqas.jpg', import.meta.url).toString(),
  },
  Shahroz: {
    name: 'Shahroz Ali Khan',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/shahroz.jpeg', import.meta.url).toString(),
  },
  Vinicius: {
    name: 'Vinicius Araujo',
    title: 'Software Engineer',
    image: new URL('cio/assets/images/april-fools/vinicius.jpeg', import.meta.url).toString(),
  },
  Irene: {
    name: 'Irene Rossetto',
    title: 'Solutions Architect',
    image: new URL('cio/assets/images/april-fools/irene.jpeg', import.meta.url).toString(),
  },
  Paola: {
    name: 'Paola Palencia',
    title: 'Senior Product Designer',
    image: new URL('cio/assets/images/april-fools/paola.jpeg', import.meta.url).toString(),
  },
  HuiHui: {
    name: 'HuiHui Yang',
    title: 'Site Reliability Engineer',
    image: new URL('cio/assets/images/april-fools/huihui.jpeg', import.meta.url).toString(),
  },
  George: {
    name: 'George Maroulis',
    title: 'Site Reliability Engineer',
    image: new URL('cio/assets/images/april-fools/george.jpeg', import.meta.url).toString(),
  },
};

const RECORDINGS: AudioAsset[] = [
  {
    language: 'en',
    name: 'Cherylyn',
    audio: new URL(
      'cio/assets/audio/april-fools/en/cherylyn-youre-doing-a-great-job-today.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Ryan',
    audio: new URL('cio/assets/audio/april-fools/en/ryan-wow.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Alyssa',
    audio: new URL('cio/assets/audio/april-fools/en/alyssa-yessssss.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Chad',
    audio: new URL('cio/assets/audio/april-fools/en/chad-what-a-great-idea.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-1.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-2.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-3.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-4.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-5.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Nat',
    audio: new URL('cio/assets/audio/april-fools/en/nat-jolly-good-6.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Bill',
    audio: new URL('cio/assets/audio/april-fools/en/bill-your-mom-would-be-so-proud.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Bill',
    audio: new URL('cio/assets/audio/april-fools/en/bill-you-deserve-a-raise.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Sarah',
    audio: new URL('cio/assets/audio/april-fools/en/sarah_a-you-deserve-a-scone.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Bill',
    audio: new URL('cio/assets/audio/april-fools/en/bill-woo-hoo.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Colin',
    audio: new URL('cio/assets/audio/april-fools/en/colin-congrats-on-being-awesome.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Rachel',
    audio: new URL('cio/assets/audio/april-fools/en/cobbo-this-is-looking-great.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Alexa',
    audio: new URL(
      'cio/assets/audio/april-fools/en/alexa-your-hard-work-will-def-pay-off.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Bri',
    audio: new URL('cio/assets/audio/april-fools/en/bri-best-workflow.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Caitlin',
    audio: new URL(
      'cio/assets/audio/april-fools/en/caitlin-look-out-awesome-campaign-coming-through.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Bekah',
    audio: new URL('cio/assets/audio/april-fools/en/bekah-youre-crushing-it.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Colby',
    audio: new URL(
      'cio/assets/audio/april-fools/en/colby-today-this-workflow-tomorrow-the-world.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Ali',
    audio: new URL('cio/assets/audio/april-fools/en/ali-i-believe-in-you.mp3', import.meta.url).toString(),
  },
  {
    language: 'en',
    name: 'Bill',
    audio: new URL(
      'cio/assets/audio/april-fools/en/bill-theres-nothing-you-cant-accomplish-today.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Jess',
    audio: new URL(
      'cio/assets/audio/april-fools/en/jess-the-potential-here-is-limitless.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'en',
    name: 'Aaron',
    audio: new URL('cio/assets/audio/april-fools/en/aaron-3-2-1-awesome.mp3', import.meta.url).toString(),
  },
  {
    language: 'hi',
    name: 'Aman',
    audio: new URL(
      'cio/assets/audio/april-fools/hi/aman-hindi-this-is-the-best-workflow-ive-ever-seen.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'pa',
    name: 'Aman',
    audio: new URL(
      'cio/assets/audio/april-fools/pa/aman-punjabi-this-is-the-best-workflow-ive-ever-seen.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'ru',
    name: 'Elena',
    audio: new URL(
      'cio/assets/audio/april-fools/ru/elena-youre-doing-a-great-job-today.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'ru',
    name: 'Gladys',
    audio: new URL(
      'cio/assets/audio/april-fools/ru/gladys-today-this-workflow-tomorrow-the-world-ru.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'es',
    name: 'Gladys',
    audio: new URL(
      'cio/assets/audio/april-fools/es/gladys-today-this-workflow-tomorrow-the-world-es.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'es',
    name: 'Marcela',
    audio: new URL('cio/assets/audio/april-fools/es/marcela-wow.mp3', import.meta.url).toString(),
  },
  {
    language: 'es',
    name: 'Pablo',
    audio: new URL('cio/assets/audio/april-fools/es/pablo-3-2-1-awesome.mp3', import.meta.url).toString(),
  },
  {
    language: 'pl',
    name: 'Adrian',
    audio: new URL('cio/assets/audio/april-fools/pl/adrian-youre-winning.mp3', import.meta.url).toString(),
  },
  {
    language: 'pl',
    name: 'Tomasz',
    audio: new URL('cio/assets/audio/april-fools/pl/tomasz-your-mom-would-be-so-proud.mp3', import.meta.url).toString(),
  },
  {
    language: 'yo',
    name: 'Debbie',
    audio: new URL('cio/assets/audio/april-fools/yo/debbie-yoruba-what-a-great-idea.mp3', import.meta.url).toString(),
  },
  {
    language: 'yo',
    name: 'Koko',
    audio: new URL('cio/assets/audio/april-fools/yo/koko-nothing-you-cant-accomplish.mp3', import.meta.url).toString(),
  },
  {
    language: 'fr',
    name: 'JP',
    audio: new URL(
      'cio/assets/audio/april-fools/fr/jp-congrats-on-being-a-fantastic-person.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'ur',
    name: 'Waqas',
    audio: new URL('cio/assets/audio/april-fools/ur/waqas-your-mom-would-be-so-proud.mp3', import.meta.url).toString(),
  },
  {
    language: 'ur',
    name: 'Shahroz',
    audio: new URL('cio/assets/audio/april-fools/ur/shahroz-jolly-good.mp3', import.meta.url).toString(),
  },
  {
    language: 'pt-br',
    name: 'Vinicius',
    audio: new URL('cio/assets/audio/april-fools/pt-br/vinicius-jolly-good.mp3', import.meta.url).toString(),
  },
  {
    language: 'es-ar',
    name: 'Irene',
    audio: new URL('cio/assets/audio/april-fools/es-ar/irene-i-believe-in-you.mp3', import.meta.url).toString(),
  },
  {
    language: 'es-mx',
    name: 'Paola',
    audio: new URL(
      'cio/assets/audio/april-fools/es-mx/paola-your-hard-work-will-definitely-pay-off.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'cn',
    name: 'HuiHui',
    audio: new URL(
      'cio/assets/audio/april-fools/cn/huihui-the-potential-here-is-limitless.mp3',
      import.meta.url,
    ).toString(),
  },
  {
    language: 'el',
    name: 'George',
    audio: new URL('cio/assets/audio/april-fools/el/george-el-amazing-job.mp3', import.meta.url).toString(),
  },
];

const DEFAULT_CONFETTI_COUNT = 200;
const DEFAULT_CONFETTI_OPTIONS = {
  disableForReducedMotion: true,
  origin: { y: 0.7 },
};

function fireSingleConfetti(particleRatio: number, opts: any) {
  confetti(
    Object.assign({}, DEFAULT_CONFETTI_OPTIONS, opts, {
      particleCount: Math.floor(DEFAULT_CONFETTI_COUNT * particleRatio),
    }),
  );
}

function fireAllConfetti() {
  fireSingleConfetti(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fireSingleConfetti(0.2, {
    spread: 60,
  });
  fireSingleConfetti(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fireSingleConfetti(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fireSingleConfetti(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}

export default class AggressivePositivityService extends Service {
  loadedAssets: Record<string, LoadedAsset> = {};
  loadingAssets: string[] = [];
  @tracked currentlyPlaying: LoadedAsset | null = null;

  get currentPerson() {
    if (this.currentlyPlaying == null) {
      return null;
    }

    let person = PEOPLE[this.currentlyPlaying.asset.name];

    if (person == null) {
      return null;
    }

    return {
      name: person.name,
      title: person.title,
      image: person.image,
    };
  }

  @action
  async loadAll() {
    RECORDINGS.forEach((asset) => {
      this.loadAsset(asset);
    });
  }

  @action
  loadAsset(asset: AudioAsset) {
    let url = asset.audio;

    if (this.loadedAssets[url] != null || this.loadingAssets.includes(url)) {
      return;
    }

    this.preloadImage(asset);

    this.loadingAssets = [...this.loadingAssets, url];
    let audioElement = new Audio(url);
    audioElement.setAttribute('data-url', url);
    audioElement.preload = 'auto';

    audioElement.addEventListener('canplaythrough', () => {
      this.loadedAssets[url] = {
        asset,
        element: audioElement,
      };
    });
  }

  @action
  preloadImage(asset: AudioAsset) {
    let person = PEOPLE[asset.name];

    if (person == null) {
      return;
    }
    let img = new Image();
    img.src = person.image;
  }

  @action
  play(url: string) {
    fireAllConfetti();

    let loadedAsset = this.loadedAssets[url];

    if (loadedAsset == null) {
      return;
    }

    this.resetCurrentIfExists();

    this.currentlyPlaying = loadedAsset;
    loadedAsset.element.play();

    loadedAsset.element.removeEventListener('ended', this.resetCurrentAfterEnd);
    loadedAsset.element.addEventListener('ended', this.resetCurrentAfterEnd);
  }

  @action
  resetCurrentAfterEnd(event: Event) {
    if (this.currentlyPlaying == null) {
      return;
    }

    let url = (event.target as HTMLAudioElement).getAttribute('data-url');

    if (url !== this.currentlyPlaying.asset.audio) {
      return;
    }

    this.resetCurrentIfExists();
  }

  @action
  resetCurrentIfExists() {
    if (this.currentlyPlaying == null) {
      return;
    }

    this.currentlyPlaying.element.pause();
    this.currentlyPlaying.element.currentTime = 0;
    this.currentlyPlaying = null;
  }

  @action
  playRandom() {
    this.resetCurrentIfExists();
    let urls = Object.keys(this.loadedAssets);
    let randomUrl = urls[Math.floor(Math.random() * urls.length)];
    this.play(randomUrl);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'aggressive-positivity': AggressivePositivityService;
  }
}
